<template>
    <master-layout>

        <!-- Breadcamb -->
        <div class="breadcamb_box m-0">
            <div>
                <h4 class="page-title"><i class="icon-directions"></i> {{ $t('lead') }}</h4>
            </div>
            <div class="t_right">
                <div class="clearfix m-b-5">
                    <pml-back-button></pml-back-button>
                </div>
            </div>
        </div>
        <div class="breadcamb_box bread_buttons align_itens_top">
            <div>
                <ol class="breadcrumb p-t-0">
                    <li>{{ $t('leads') }}</li>
                    <li class="active">{{ lead.full_name }}</li>
                </ol>
            </div>
            <div>
                <button class="m-b-5 btn btn-warning waves-light" @click.prevent="fetch()">
                    <span class="btn-label"><i class="fa fa-refresh" :class="{ 'fa-spin': isFetching }"></i></span> {{ $t('refresh') }}
                </button>
                <router-link :to="{ name: 'leads.deals.create', params: { id: lead.id } }" class="m-b-5 btn btn-default waves-light">
                    <span class="btn-label"><i class="fa fa-plus-circle"></i></span> {{ $t('deal') }}
                </router-link>
            </div>
        </div>

        <div class="box_infos_right bg_load_null" v-pml-block="!lead.id">
            <div class="box_contents">
                <PmlProfile :lead="lead"></PmlProfile>
            </div>
            <div class="box_contents">
                <PmlItem v-for="item in deals" :key="item.id" :item="item" @deleted="deleted"></PmlItem>
                <div v-if="!deals.length">
                    {{ $t('no_records_found') }}
                </div>
            </div>
        </div>
    </master-layout>
</template>

<script>
    import PmlProfile from './profile/Main.vue'
    import PmlItem from './Deal.vue'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'Lead',
        components: { PmlProfile, PmlItem },
        data () {
            return {
                isFetching: false
            }
        },
        metaInfo () {
            return {
                title: this.lead.name
            }
        },
        created () {
            this.fetch()
        },
        destroyed () {
            this.clearLead()
        },
        watch: {
            '$route' (val, old) {
                if (val.name === old.name && val.params.id !== old.params.id)
                    this.fetch()
            }
        },
        computed: {
            ...mapGetters({
                'lead': 'getLeadInfo',
                'deals': 'getLeadDeals'
            })
        },
        methods: {
            ...mapActions([ 'loadLead', 'clearLead', 'destroyLeadDeal' ]),
            fetch () {
                this.isFetching = true

                this.loadLead(this.$route.params.id)
                    .then(() => { this.isFetching = false })
            },
            deleted (id) {
                this.destroyLeadDeal(id)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/leads/components/show/Main.vue